/* Mirror (9/23/26): display-case SHOUTY vendors (RDI feeds uppercase). Mirrors snippets/brand-name.liquid. */
window.cgBrandName = function (s) {
  s = (s || '').trim();
  if (!s || s !== s.toUpperCase() || s.toLowerCase() === s.toUpperCase()) return s;
  var KEEP = /^(CHROME|LAFCO|SJS|OAS|MCM|DVF|UGG|MLB|NFL|NBA|NYC|USA|NY|LA|TX|KC|SF|DC|UK|US|LV|PJ|DL|OB|AJ|JW|MJR|USB|LSA|RVCA|ASTR|ASKK|NIC|ZOE|TTU)$/;
  var SMALL = /^(THE|OF|AND|FOR|IN|BY|AT|TO)$/;
  return s.split(' ').map(function (w, i) {
    var core = w.replace(/[^A-Za-z0-9]/g, '');
    if (/\d/.test(w)) return w;
    if (i > 0 && SMALL.test(core)) return w.toLowerCase();
    if (KEEP.test(core) || core.length === 1 || /^([A-Z]\.)+$/.test(w)) return w;
    return w.split('-').map(function (h) {
      return h.split('.').map(function (d) {
        return d.split("'").map(function (a, j) { return (j > 0 && a.length === 1) ? a.toLowerCase() : a.charAt(0).toUpperCase() + a.slice(1).toLowerCase(); }).join("'");
      }).join('.');
    }).join('-');
  }).join(' ');
};
